(() => {
  'use strict';

  /**
   * AOCTANT Sample Cities (funnel F4).
   * - Arrows scroll the native scroll-snap track by about one view; they show only when
   *   the track overflows and disable at either end.
   * - "Make this city" on the same page as the request form fills the form in place,
   *   updates the address and scrolls to it, without a reload. Elsewhere the link
   *   simply opens the form page with ?place= / ?country=.
   * Click handling is delegated on document, so Theme Editor section reloads need no re-binding.
   */

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setupArrows = (root) => {
    const track = root.querySelector('[data-track]');
    const arrows = root.querySelector('[data-arrows]');
    if (!track || !arrows || root.dataset.citiesBound === 'true') return;
    root.dataset.citiesBound = 'true';
    const prev = arrows.querySelector('[data-prev]');
    const next = arrows.querySelector('[data-next]');

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      arrows.hidden = max <= 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    };
    const step = (dir) => {
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  };

  const init = (scope = document) => scope.querySelectorAll('[data-aoctant-sample-cities]').forEach(setupArrows);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-make-city]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    const url = new URL(link.href, window.location.href);
    if (url.pathname !== window.location.pathname) return;
    const anchor = document.getElementById(link.dataset.anchor || 'map-request');
    const form = anchor && anchor.querySelector('.aoctant-map-request__form');
    if (!form) return;

    event.preventDefault();
    const place = form.elements.namedItem('place');
    const country = form.elements.namedItem('country');
    if (place) {
      place.value = link.dataset.place || '';
      place.removeAttribute('aria-invalid');
    }
    if (country) country.value = link.dataset.country || '';
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    anchor.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
    if (place) place.focus({ preventScroll: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
